import React from 'react';
import { useState } from 'react';
import Logo from './Logo';
import MobilePopupMenu from './MobilePopupMenu';
import { FiMenu } from 'react-icons/fi';

const MobileHeaderContent = ({ content, showMobileMenu, toggleMobileMenu }) => {
  return (
    <div className="mobile-header-content-wrapper">
      <div className="mobile-header-left">
        <Logo image="/images/nav_footer/Atlantic_labs_long.svg" />
      </div>
      <div className="mobile-header-right">
        <div className="hamburger-button" onClick={toggleMobileMenu}>
          <FiMenu />
        </div>
      </div>
      <MobilePopupMenu content={content.nav} showMobileMenu={showMobileMenu} toggleMobileMenu={toggleMobileMenu} />
    </div>
  );
};

export default MobileHeaderContent;

// CSS Structure
/* 
.mobile-header-content-wrapper{
  .mobile-header-left{
    .logo{
      .logo-img{
      }
    }
  }
  .mobile-header-right{
    .mobile-hamburger-wrapper{
      .hamburger-button{
      }
    }
  }
          .mobile-popup-menu {
          .mobile-popup-menu-header {
            .logo {
              .logo-img {
              }
            }
            .close-mobile-popup-menu {
              .close-button {
              }
            }
          }

          .main-menu-nav {
            .main-menu-nav-list {
              .main-menu-list-item {
                .main-menu-link {
                }
                &.has-dropdown {
                  .main-menu-link {
                  }
                }
              }
            }
            .submenu-wrapper {
              .container {
                .submenu-title-group {
                  .submenu-title {
                  }
                }
                .submenu-list {
                  .submenu-item {
                    .submenu-link {
                    }
                    &.btn-wrapper {
                      &.btn-default {
                      }
                    }
                  }
                }
                .contact-us-wrapper {
                  .contact-us-link {
                    .contact-us-content {
                      .assist-text {
                      }
                      .phone-img-wrapper {
                      }
                      .phone-icon-img {
                      }
                      .contact-us-rep-img {
                      }
                    }
                    .contact-us-img-bg {
                    }
                  }
                }
              }
            }
          }

          .contact-us-mobile-wrapper {
            .contact-us-mobile {
              .content {
                .assist-text {
                }
                .phone-group {
                  .phone-decor-img {
                  }
                  .phone-number {
                  }
                }
              }
            }
          }
          &.active {
          }
        }
}

*/
